import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../../../app/store/utils/baseQueryWithReauth';

export interface IStockOwnerApiDto {
  id: number;
  userId: number;
  companyId: number;
  name: string;
  isActive: boolean;
  meta: {
    templateType?: 'system' | 'personal';
    templateValue?: string;
    [key: string]: any;
  } | null;
  createdAt: string;
  updatedAt: string;
}

export interface IUpdateStockOwnerTemplateDto {
  id: number;
  templateType: 'system' | 'personal';
  templateValue: string;
}

export const stockOwnersApi = createApi({
  reducerPath: 'stockOwnersApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['StockOwners'],
  endpoints: build => ({
    getStockOwnersByCompany: build.query<IStockOwnerApiDto[], number>({
      query: companyId => ({
        url: `/system/stock-owners/company/${companyId}`,
        method: 'GET',
      }),
      transformResponse: (response: { data: IStockOwnerApiDto[] }) => response.data,
      providesTags: ['StockOwners'],
    }),

    updateStockOwnerTemplate: build.mutation<IStockOwnerApiDto, IUpdateStockOwnerTemplateDto>({
      query: ({ id, templateType, templateValue }) => ({
        url: `/system/stock-owners/${id}/template`,
        method: 'PATCH',
        body: { templateType, templateValue },
      }),
      transformResponse: (response: { data: IStockOwnerApiDto }) => response.data,
      invalidatesTags: ['StockOwners'],
    }),
  }),
});

export const {
  useGetStockOwnersByCompanyQuery,
  useUpdateStockOwnerTemplateMutation,
} = stockOwnersApi;
